import * as Sentry from "@sentry/nextjs";

export class AssertionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "AssertionError";
  }
}

export function assert(condition: boolean, message: string): asserts condition {
  if (!condition) {
    // Log to Sentry before throwing
    Sentry.captureException(new AssertionError(message));
    if (!process.env.NODE_ENV.includes("production")) {
      throw new AssertionError(message);
    }
  }
}

export function assertDefined<T>(
  value: T | undefined | null,
  message: string,
): asserts value is T {
  assert(value !== undefined && value !== null, message);
}
